import { trackSelfDescribingEvent as e } from "@snowplow/browser-tracker";
import a from "react";
const p = (s) => ({
  schema: "iglu:com.starsgroup/casino_game/jsonschema/2-0-1",
  data: s
}), h = (s) => ({
  schema: "iglu:com.starsgroup/casino_race/jsonschema/1-0-0",
  data: s
}), l = (s) => ({
  schema: "iglu:com.starsgroup/user/jsonschema/1-0-0",
  data: s
}), g = (s) => ({
  schema: "iglu:com.starsgroup/desktop_screen/jsonschema/1-0-2",
  data: s
}), j = (s) => ({
  schema: "iglu:com.starsgroup/crm_package/jsonschema/1-0-0",
  data: s
}), _ = (s) => ({
  schema: "iglu:com.starsgroup/poker_cash_game/jsonschema/1-0-0",
  data: s
}), v = (s) => ({
  schema: "iglu:com.starsgroup/deposit/jsonschema/1-0-0",
  data: s
}), w = (s) => ({
  schema: "iglu:com.starsgroup/sports_bet/jsonschema/3-0-2",
  data: s
}), d = (s) => ({
  schema: "iglu:com.starsgroup/sports_race/jsonschema/1-0-1",
  data: s
}), x = (s) => ({
  schema: "iglu:com.starsgroup/crm_zone/jsonschema/2-0-0",
  data: s
}), k = (s) => ({
  schema: "iglu:com.starsgroup/sports_event/jsonschema/3-0-0",
  data: s
}), S = (s) => ({
  schema: "iglu:com.starsgroup/app/jsonschema/3-0-1",
  data: s
}), f = (s) => ({
  schema: "iglu:com.starsgroup/withdrawal/jsonschema/1-0-1",
  data: s
}), b = (s) => ({
  schema: "iglu:com.starsgroup/poker_tournament/jsonschema/1-0-0",
  data: s
}), R = (s) => ({
  schema: "iglu:com.starsgroup/poker_cash_table_stats/jsonschema/1-0-0",
  data: s
}), M = (s) => ({
  schema: "iglu:com.starsgroup/sports_selection/jsonschema/2-0-0",
  data: s
}), E = (s) => ({
  schema: "iglu:com.starsgroup/sports_market/jsonschema/2-0-0",
  data: s
}), F = (s) => ({
  schema: "iglu:com.starsgroup/sports_sport/jsonschema/1-0-0",
  data: s
}), r = (s) => ({
  schema: "iglu:com.starsgroup/widget/jsonschema/1-0-2",
  data: s
}), A = (s) => ({
  schema: "iglu:com.starsgroup/sports_competition/jsonschema/1-0-0",
  data: s
}), C = (s) => ({
  schema: "iglu:com.starsgroup/bonus/jsonschema/1-0-0",
  data: s
});
var n = /* @__PURE__ */ ((s) => (s.Account = "Account", s.Auth = "Auth", s.Casino = "Casino", s.Deposit = "Deposit", s.Withdraw = "Withdraw", s.CRM = "CRM", s.ManageCurrencies = "Manage Currencies", s.P2pTransfer = "P2P Transfer", s.Rewards = "Rewards", s.RMF = "RMF", s.Signup = "Signup", s.Sports = "Sports", s.Stars = "Stars", s.TransactionHistory = "Transaction History", s))(n || {});
const m = (s = [], o) => s.find(({ schema: c }) => c === o.schema), t = (s = {}) => {
  const o = [];
  if (s.widget) {
    const c = r(s.widget);
    m(s.entities, c) || o.push(c);
  }
  return s.entities && o.push(...s.entities), o;
}, P = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/panel_toggle/jsonschema/1-0-1",
      data: s
    },
    context: t(o)
  });
}, V = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/widget_view/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, z = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/tab_click/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, D = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/screen_close/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, Z = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/crm_zone_click/jsonschema/2-0-0",
      data: s
    },
    context: t(o)
  });
}, G = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/input_fill/jsonschema/3-0-1",
      data: s
    },
    context: t(o)
  });
}, H = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/button_click/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, W = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/results_view/jsonschema/2-0-0",
      data: s
    },
    context: t(o)
  });
}, B = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/link_click/jsonschema/2-0-1",
      data: s
    },
    context: t(o)
  });
}, I = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/crm_zone_view/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, O = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/application_open/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, q = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/screen_focus/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, J = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/application_install/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, K = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/input_focus/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, L = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/list_click/jsonschema/1-0-0",
      data: s
    },
    context: t(o)
  });
}, N = (s, o) => {
  e({
    event: {
      schema: "iglu:com.starsgroup/error_view/jsonschema/3-0-1",
      data: s
    },
    context: t(o)
  });
}, Q = a.createContext({
  category: n.Stars
});
export {
  n as TrackingCategory,
  Q as TrackingContext,
  S as app,
  J as applicationInstall,
  O as applicationOpen,
  C as bonus,
  H as buttonClick,
  p as casinoGame,
  h as casinoRace,
  j as crmPackage,
  x as crmZone,
  Z as crmZoneClick,
  I as crmZoneView,
  v as deposit,
  g as desktopScreen,
  N as errorView,
  t as getEntities,
  G as inputFill,
  K as inputFocus,
  B as linkClick,
  L as listClick,
  P as panelToggle,
  _ as pokerCashGame,
  R as pokerCashTableStats,
  b as pokerTournament,
  W as resultsView,
  D as screenClose,
  q as screenFocus,
  w as sportsBet,
  A as sportsCompetition,
  k as sportsEvent,
  E as sportsMarket,
  d as sportsRace,
  M as sportsSelection,
  F as sportsSport,
  z as tabClick,
  l as user,
  r as widget,
  V as widgetView,
  f as withdrawal
};
